/**
 * @generated SignedSource<<fc19115546b338bea526e4b36f590cce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastPickerPopoverItem_dashboard$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "StorecastPickerPopoverItem_dashboard";
};
export type StorecastPickerPopoverItem_dashboard$key = {
  readonly " $data"?: StorecastPickerPopoverItem_dashboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastPickerPopoverItem_dashboard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastPickerPopoverItem_dashboard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "c6f9ef5b09d24b3d79f9307cf6a923a4";

export default node;
